import { LaunchChangePlanServiceModule } from './launchChangePlan.service';

export const ChangePlanClickModule = angular
    .module('app.components.changePlan.changePlanClick', [
        LaunchChangePlanServiceModule
    ]).directive('changePlanClick', (launchChangePlanService) => {
        return {
            restrict: 'A',
            link: (scope, element) => {
                element.on('click', (event) => {
                    launchChangePlanService.openModal(event);
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/changePlan/changePlanClick.directive.js